<template>
	<div class="IndexBox" style="background: url('./static/images/profile-bg.png');background-size: 100% 100%;height: 100%;width: 100%;">
	  <div class="ScrollBox">
		  <van-nav-bar
		    fixed
		    :border="false"
		    :title="$t('user.positions[0]')"
		    left-arrow
		    @click-left="$router.go(-1)"
		  />
		<div style="padding-top:15%;text-align: center;">
			  <van-cell class="info" :border="false">
				<template #icon v-if="UserInfo.pic.length>0">
				  <van-image 
				  class="head"
				  :src="`${UserInfo.pic}`" 
				  width="100px"
				  />
				</template>	
				<template #icon v-else>
				  <van-image  src="./static/head/head.png" width="100px"/>
				</template>
			    <template #title>
					<div style="padding:10px;text-align: left;">{{$t('user.positions[1]')}}：{{JobStatistics['location']}}</div>
					<div style="padding:10px;text-align: left;">{{$t('user.current[1]')}}：{{JobStatistics['nextPost']}}</div>
					<div style="padding:10px;text-align: left;">{{$t('userInfo.default[5]')}}：{{UserInfo.realname}}</div>
			    </template>
				
			  </van-cell>
			  
			  <div style="display: flex;width: 100%;flex-wrap: wrap;margin-bottom: 4rem;">
			  
			   <div style="display: flex;position: relative; padding: 0.625rem;" v-for="item in InitData.UserGradeList" :key="item.grade" v-if="item.state==1&&item.grade!=1">
				   <div :style="{ backgroundColor: getRandomColor(item.grade) }" class="hue" style="display: inline-block;"></div> 
				   <div style="display: inline-block;"><pre> {{item.name}}:{{JobStatistics.levelStatistics[item.grade]}}  </pre>  </div>
				</div>
			  </div>
			  <div >
				  <p style="font-weight: bold;font-size: 1rem;" @click="getMember(1)">{{$t('user.subordinate[12]')}}></p>
				  <div style="border-top: 2px solid black;margin-top: 0.625rem;">
					  <div style="display: flex;padding: 0.3125rem 0.625rem;">
						  <div style="width: 50%;text-align: left;">{{$t('user.subordinate[0]')}}</div>
						  <div style="width: 50%;text-align:right" @click="getMember(2)">{{$t('user.subordinate[3]')}} ></div>
					  </div>
					  <div style="display: flex;flex-wrap: wrap;">
						  <div class="content">
							  <div>
								  {{JobStatistics.statisticalData.a["count"]}}
							  </div>
							  <div>
								  {{$t('user.subordinate[4]')}}
							  </div>
						  </div>
						  <div class="content">
						  		<div>
						  			{{JobStatistics.statisticalData.a["totalRevenue"]}}
						  		</div>
						  		<div>
						  			{{$t('user.subordinate[5]')}}
						  		</div>
						  </div>
						  <div class="content">
						  		<div>
						  			{{JobStatistics.statisticalData.a["withdrawal"]}}
						  		</div>
						  		<div>
						  			{{$t('user.subordinate[6]')}}
						  		</div>
						  </div>
						  <div class="content">
						  		<div>
						  			{{JobStatistics.statisticalData.a["teamIncome"]}}
						  		</div>
						  		<div>
						  			{{$t('user.subordinate[7]')}}
						  		</div>
						  </div>
						  
					  </div>
				  </div>
				  <div style="border-top: 2px solid black;margin-top: 0.625rem;">
					  <div style="display: flex;padding: 0.3125rem 0.625rem;">
						  <div style="width: 50%;text-align: left;">{{$t('user.subordinate[1]')}}</div>
						  <div style="width: 50%;text-align:right" @click="getMember(3)">{{$t('user.subordinate[3]')}} ></div>
					  </div>
					  <div style="display: flex;flex-wrap: wrap;">
						  <div class="content">
							  <div>
								  {{JobStatistics.statisticalData.b["count"]}}
							  </div>
							  <div>
								  {{$t('user.subordinate[4]')}}
							  </div>
						  </div>
						  <div class="content">
								<div>
									{{JobStatistics.statisticalData.b["totalRevenue"]}}
								</div>
								<div>
									{{$t('user.subordinate[5]')}}
								</div>
						  </div>
						  <div class="content">
								<div>
									{{JobStatistics.statisticalData.b["withdrawal"]}}
								</div>
								<div>
									{{$t('user.subordinate[6]')}}
								</div>
						  </div>
						  <div class="content">
								<div>
									{{JobStatistics.statisticalData.b["teamIncome"]}}
								</div>
								<div>
									{{$t('user.subordinate[7]')}}
								</div>
						  </div>
						  
					  </div>
				  </div>
				  <div style="border-top: 2px solid black;margin-top: 0.625rem;">
					  <div style="display: flex;padding: 0.3125rem 0.625rem;">
						  <div style="width: 50%;text-align: left;">{{$t('user.subordinate[2]')}}</div>
						  <div style="width: 50%;text-align:right" @click="getMember(4)">{{$t('user.subordinate[3]')}} ></div>
					  </div>
					  <div style="display: flex;flex-wrap: wrap;">
						  <div class="content">
							  <div>
								  {{JobStatistics.statisticalData.c["count"]}}
							  </div>
							  <div>
								  {{$t('user.subordinate[4]')}}
							  </div>
						  </div>
						  <div class="content">
								<div>
									{{JobStatistics.statisticalData.c["totalRevenue"]}}
								</div>
								<div>
									{{$t('user.subordinate[5]')}}
								</div>
						  </div>
						  <div class="content">
								<div>
									{{JobStatistics.statisticalData.c["withdrawal"]}}
								</div>
								<div>
									{{$t('user.subordinate[6]')}}
								</div>
						  </div>
						  <div class="content">
								<div>
									{{JobStatistics.statisticalData.c["teamIncome"]}}
								</div>
								<div>
									{{$t('user.subordinate[7]')}}
								</div>
						  </div>
						  
					  </div>
				  </div>
			  </div>
		  </div>
		  <van-popup v-model="showCon" position="bottom" closeable close-on-popstate  style="width: 100%;height: 100%;background-color:rgb(255, 255, 255);color:#fff;">
		    <div class="ScrollBox" style="padding: 16px 20px;">
		      <h3 style="text-align: center;margin-bottom: 20px;color:#333">{{infoData.title}}</h3>
		      <div class="Content" style="text-align: justify;color:#333" v-html="infoData.content"></div>
		    </div>
		  </van-popup>
		</div>
	</div> 
</template>

<script>
export default {
	name:"positions",
	data(){
		return {
			showCon: false,
			infoData:'',
			randomColor: this.getRandomColor(),
			JobStatistics:[]
			
			
		}
	},
	computed: {
	},
	watch: {
	},
	created() {
		this.$Model.GetUserInfo();
		this.$parent.navBarTitle = this.$t("user.positions[0]")
		this.$Model.JobStatistics(data=>{
			if(data.code==1){
				this.JobStatistics = data.data
				
			}
		});
		
	},
	mounted() {
	},
	activated() {},
	destroyed() {},
	methods: {
		getMember(id){
			this.$router.push(`/user/member/${id}`)
		},
		getStr(n1,n2) {
			return n1+"/"+n2;
		},
		openShow(data) {
		  this.showCon = true
		  this.infoData = data
		},
		getRandomColor(id) {
		var a=[
			'#ff0000',
			'#00ff00',
			'#0000ff',
			'#00ffff',
			'#ff00ff',
			'#ffff00',
			'#7da076',
			'#aab2a8',
			'#047878',
			'#fc97f2',
			'#e68419',
		];	
		      return a[id];
		},
		
	}
}
	
</script>

<style>
	.van-progress__pivot{font-size: 14px;}
	.hue{
		width: 1.875rem;
		height: 0.9375rem;
		border-radius: 0.3125rem;
	}
	.content{
		margin-top: 1rem;
		width: 50%;
		height: 4rem;
	}
</style>